import ServiceContainer from '../../atoms/container/serviceContainer';
import usePlayerServices from '@shared/components/utils/hooks/usePlayerServices';
import { ServicesProps as Props } from '@shared/types/props/services';

export default function Services({ channel }: Props) {
  const services = usePlayerServices(channel);

  return (
    <>
      {services?.map((service, index) => {
        const { active, Icon, height, width } = service;
        return (
          <ServiceContainer key={index} active={active}>
            <Icon height={height || 20} width={width || 20} />
          </ServiceContainer>
        );
      })}
    </>
  );
}
